import { FieldValidator } from 'final-form';
import sanitizeHtml from 'sanitize-html';
import { i18n } from './i18n';
import { rcEnums } from 'types/rc.enums';

export const required: FieldValidator<unknown> = value => {
	return value ? undefined : 'Required';
};

export const sanitize = (str: string, keepStyles = true) => {
	const allowedTags = ['p', 'span', 'li', 'ul', 'ol', 'strong', 'em', 'a', 'br', 'img'];
	const allowedAttributes = {
		p: ['style'],
		span: ['style'],
		li: ['style'],
		ul: ['style'],
		ol: ['style'],
		strong: ['style'],
		em: ['style'],
		a: ['style', 'href', 'target'],
		img: ['src', 'alt', 'width', 'height', 'style'],
	};

	const allowedStyles = !keepStyles
		? {
				'*': {
					'text-decoration': [/^underline$/],
				},
		  }
		: undefined;

	return sanitizeHtml(str, {
		allowedTags,
		allowedAttributes,
		allowedStyles,
	});
};

export const capitalize = (s: string) => {
	if (typeof s !== 'string') {
		return '';
	}
	return s.charAt(0).toUpperCase() + s.slice(1);
};

export const Pricify = (price?: number, disableToFixed?: boolean) => {
	if (price) {
		return price > 0
			? `${i18n.currency.USD.symbol}${disableToFixed ? price : price.toFixed(2)}`
			: `-${i18n.currency.USD.symbol}${disableToFixed ? price : (price * -1).toFixed(2)}`;
	}
	return '-';
};

const { AddressComponentFieldEnum } = rcEnums;

export const formatAddressComponent = (address_components: google.maps.GeocoderAddressComponent[]) => {
	let country;
	let city;
	let state;

	let streetAdress = '';
	let zip = '';
	for (const component of address_components as google.maps.GeocoderAddressComponent[]) {
		const componentType = component.types[0];

		switch (componentType) {
			case AddressComponentFieldEnum.STREET_NUMBER: {
				streetAdress = `${component.long_name} ${streetAdress}`;
				break;
			}

			case AddressComponentFieldEnum.ROUTE: {
				streetAdress += component.short_name;
				break;
			}

			case AddressComponentFieldEnum.POSTAL_CODE: {
				zip += component.long_name;
				break;
			}

			case AddressComponentFieldEnum.POSTAL_CODE_SUFFIX: {
				zip = `${zip}-${component.long_name}`;
				break;
			}

			case AddressComponentFieldEnum.LOCALITY: {
				city = component.long_name;
				break;
			}

			case AddressComponentFieldEnum.ADMINISTRATIVE_AREA: {
				state = component.long_name;
				break;
			}

			case AddressComponentFieldEnum.COUNTRY: {
				country = component.short_name;
				break;
			}
		}
	}

	return {
		country,
		state,
		city,
		street: streetAdress,
		zip,
	};
};
